import React from 'react';
import { useParams } from 'react-router-dom';
// import { useTheme } from '../App';
import { Flex, Icon } from '@chakra-ui/react';
import { FiCheckCircle, FiXCircle, FiMinusCircle } from 'react-icons/fi';

function formatDate(iso) {
  const d = new Date(iso);
  return d.toLocaleString();
}

export default function TestRunHistoryDetail({ selectedProject, runs, loading }) {
  const { runId } = useParams();
  // const { dark } = useTheme();
  let run = null;
  if (selectedProject === 'ALL PROJECTS') {
    run = (runs || []).find(r => r.id === runId);
  } else {
    run = (runs || []).find(r => r.id === runId && r.project === selectedProject);
  }
  if (loading) return <div style={{ padding: 32, color: 'var(--color-text-dark)' }}>Loading test run...</div>;
  if (!run) return <div style={{ padding: 32, color: 'var(--color-text-dark)' }}>Test run not found.</div>;

  const summary = run.summary || {};
  const testcases = Array.isArray(run.testcases) ? run.testcases : [];

  return (
    <div style={{ padding: '2rem', background: 'var(--color-background-main)', color: 'var(--color-text-main)' }}>
      <h2 style={{ fontWeight: 700, fontSize: 22, marginBottom: 12, color: 'var(--color-text-dark)' }}>Test Run Details</h2>
      <div style={{ marginBottom: 18, color: 'var(--color-text-light)' }}>Run ID: <b>{run.id}</b> &nbsp;|&nbsp; Date: <b>{formatDate(run.timestamp)}</b></div>
      <div style={{ marginBottom: 24, color: 'var(--color-text-main)' }}>
        <b>Total:</b> {summary.tests ?? '-'} &nbsp;|&nbsp;
        <span style={{ color: 'var(--color-status-success)', fontWeight: 600 }}><b>Passed:</b> {summary.tests !== undefined && summary.failures !== undefined && summary.errors !== undefined ? summary.tests - summary.failures - summary.errors : '-'}</span> &nbsp;|&nbsp;
        <span style={{ color: 'var(--color-status-danger)', fontWeight: 600 }}><b>Failed:</b> {summary.failures !== undefined && summary.errors !== undefined ? summary.failures + summary.errors : '-'}</span>
      </div>
      <h3 style={{ fontWeight: 600, fontSize: 18, marginBottom: 12, color: 'var(--color-text-dark)' }}>Test Cases</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', background: 'var(--color-background-card)', borderRadius: 'var(--card-border-radius)', overflow: 'hidden', boxShadow: 'var(--card-box-shadow)', color: 'var(--color-text-main)' }}>
        <thead>
          <tr style={{ background: 'var(--color-accent-bg)', borderBottom: '2px solid var(--color-primary-green)' }}>
            <th style={{ textAlign: 'left', padding: '10px 14px', color: 'var(--color-primary-green)', fontWeight: 600 }}>Module</th>
            <th style={{ textAlign: 'left', padding: '10px 14px', color: 'var(--color-primary-green)', fontWeight: 600 }}>Test Name</th>
            <th style={{ textAlign: 'left', padding: '10px 14px', color: 'var(--color-primary-green)', fontWeight: 600 }}>Status</th>
            <th style={{ textAlign: 'left', padding: '10px 14px', color: 'var(--color-primary-green)', fontWeight: 600 }}>Duration</th>
          </tr>
        </thead>
        <tbody>
          {testcases.length === 0 ? (
            <tr><td colSpan={4} style={{ textAlign: 'center', color: 'var(--color-text-light)', padding: 24 }}>No test cases found.</td></tr>
          ) : testcases.map((tc, i) => {
            const failed = tc.failure || tc.error;
            const skipped = tc.skipped;
            const passed = !failed && !skipped;
            let rowBackground = i % 2 === 0 ? 'var(--color-background-card)' : 'var(--color-background-main)';
            if (failed) rowBackground = 'var(--color-status-danger-bg)';
            else if (passed) rowBackground = 'var(--color-status-success-bg)';

            return (
              <tr key={i} style={{ borderBottom: '1px solid var(--color-border-light)', background: rowBackground }}>
                <td style={{ padding: '8px 14px', color: 'var(--color-text-dark)' }}>{tc.classname || 'Unknown'}</td>
                <td style={{ padding: '8px 14px', color: 'var(--color-text-dark)' }}>{tc.name}</td>
                <td style={{ padding: '8px 14px', 
                  color: failed ? 'var(--color-status-danger)' : passed ? 'var(--color-status-success)' : 'var(--color-text-light)', 
                  fontWeight: 600 
                }}>
                  <Flex align="center" gap={1}>
                    {failed ? <Icon as={FiXCircle} /> : passed ? <Icon as={FiCheckCircle} /> : <Icon as={FiMinusCircle} />}
                    {failed ? 'Failed' : passed ? 'Passed' : 'Skipped'}
                  </Flex>
                </td>
                <td style={{ padding: '8px 14px', color: 'var(--color-text-dark)' }}>{tc.time || '-'}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
} 